import ModalAnnouncementUserPicker from "./ModalAnnouncementUserPicker";

export default ModalAnnouncementUserPicker;
